import React, { useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { useSelector } from 'react-redux'
import useWindowSize from '../../../../utils/useWindowSize'

import { colors } from '../../../styles/global'
import TaskEditForm from './TaskEditForm'
import { applyPopoverWidth } from '../../../../utils/HelperFunctions'
import ModalHeader from '../ModalHeader'
import AssigneeArea from './AssigneeArea'
import { translate } from '../../../../i18n/TranslationService'
import ProjectFilter from '../../../GlobalSearchAlgolia/Filter/ProjectFilter'
import { getSafeAreaModalMaxHeight } from '../../../../utils/modalSafeArea'
import SelectedGoalRow from './SelectedGoalRow'
import CreateTaskFileDropZone from './CreateTaskFileDropZone'

export default function MainModal({
    projectId,
    closeModal,
    modalTitle,
    task,
    showAssigneeModal,
    showDueDate,
    showRecurring,
    showParentGoal,
    showPrivacy,
    showAssignee,
    showSelectProject,
    createTask,
    setTask,
    showMoreOptions,
    selectedProject,
    activeGoal,
    widthStyle,
    onFilesDropped,
    uploadingDraft,
    pushToTalkHandoff,
    claimDictatedTaskInBackground,
}) {
    const smallScreenNavigation = useSelector(state => state.smallScreenNavigation)
    const [, windowHeight] = useWindowSize()
    const [mentions, setMentions] = useState([])

    const title = modalTitle || translate('Add task')

    return (
        <CreateTaskFileDropZone onFilesDropped={onFilesDropped}>
            <View
                style={[
                    localStyles.container,
                    applyPopoverWidth(),
                    smallScreenNavigation && { minWidth: 315 },
                    { maxHeight: getSafeAreaModalMaxHeight(windowHeight) },
                    // AT-2582: last, so the responsive add-task width overrides
                    // both the legacy popover width and small-screen minimum.
                    widthStyle,
                ]}
            >
                <ModalHeader closeModal={closeModal} title={title} description="" />
                {selectedProject && (
                    <ProjectFilter
                        setShowSelectProjectModal={() => {
                            showSelectProject(true)
                        }}
                        selectedProject={selectedProject}
                        containerStyle={{ marginBottom: activeGoal ? 0 : 16, marginTop: 0 }}
                        text="Select project"
                    />
                )}
                {selectedProject && activeGoal && (
                    <SelectedGoalRow activeGoal={activeGoal} showParentGoal={showParentGoal} />
                )}
                <AssigneeArea
                    projectId={projectId}
                    task={task}
                    showAssignee={showAssignee}
                    containerStyle={{ top: selectedProject ? (activeGoal ? 146 : 106) : 50 }}
                />
                <TaskEditForm
                    projectId={projectId}
                    isAssigneeVisible={showAssigneeModal}
                    task={task}
                    setTask={setTask}
                    onSuccess={createTask}
                    mentions={mentions}
                    setMentions={setMentions}
                    showDueDate={showDueDate}
                    showPrivacy={showPrivacy}
                    showRecurring={showRecurring}
                    showParentGoal={showParentGoal}
                    showMoreOptions={showMoreOptions}
                    uploadingDraft={uploadingDraft}
                    pushToTalkHandoff={pushToTalkHandoff}
                    claimDictatedTaskInBackground={claimDictatedTaskInBackground}
                />
            </View>
        </CreateTaskFileDropZone>
    )
}

const localStyles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        paddingHorizontal: 16,
        paddingVertical: 16,
        borderRadius: 4,
        backgroundColor: colors.Secondary400,
        boxShadow: '0px 4px 16px rgba(78,93,120,0.56)',
        elevation: 3,
        height: 'auto',
    },
})
